import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Recipient } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const getSignatureRecipient = (
  constructGet: ConstructGet,
  params: RequestConfig['params'],
): Promise<NonPaginatedResponse<Recipient> | undefined> =>
  constructGet<NonPaginatedResponse<Recipient>>(
    `${SIGNATURE_BASE_PATH}/recipient`,
    { params },
    { transformerSet: TransformerSet.PreserveKeys },
  );
